import { render, staticRenderFns } from "./IconeSvg.vue?vue&type=template&id=85992f16"
import script from "./IconeSvg.vue?vue&type=script&lang=js"
export * from "./IconeSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports